import { render, staticRenderFns } from "./CauHinhForm.vue?vue&type=template&id=539d4474&"
import script from "./CauHinhForm.vue?vue&type=script&lang=js&"
export * from "./CauHinhForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports